import { useState, useEffect, useMemo, useRef } from "react";
import { API_BASE } from "../utils/draftutils";
import TreeCanvas from "../components/gerarchia/treecanvas";
import { collectSubtree, groupRoots } from "../utils/gerarchiautils";
import { useOutletContext } from "react-router-dom";

export default function CreaProposta() {
  const [loading, setLoading] = useState(true);
  const [nodes, setNodes] = useState([]);
  const [err, setErr] = useState("");

  const [selectedRootId, setSelectedRootId] = useState(null);
  const [fase, setFase] = useState("richiesta"); 
  const [fogliaRichiesta, setFogliaRichiesta] = useState(null);
  const [oreRichieste, setOreRichieste] = useState(1);
  const [showOreModal, setShowOreModal] = useState(false);
  const [oreTemp, setOreTemp] = useState(1);
  const [pendingLeaf, setPendingLeaf] = useState(null);
  const [fogliaOfferta, setFogliaOfferta] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  
  const messaggio = err || successMsg; 
  const { username } = useOutletContext(); 
  const titleRef = useRef(null);

  useEffect(() => {
  let alive = true;
  (async () => {
    try {
      const res = await fetch(`${API_BASE}/api/gerarchia/visualnodes`, {
        credentials: "include",  
      });
      if (!res.ok) throw new Error("Errore caricamento nodi");
      const data = await res.json();
      const adapted = (Array.isArray(data) ? data : []).map(adaptNodeFromApi);
      if (alive) setNodes(adapted);
    } catch (e) {
      if (alive) setErr("Errore: " + e.message);
    } finally {
      if (alive) setLoading(false);
    }
  })();
  return () => { alive = false; };
}, []);

  const roots = useMemo(() => groupRoots(nodes), [nodes]);

  useEffect(() => {
    if (!roots.length) return setSelectedRootId(null);
    if (!selectedRootId || !roots.some(r => r.tempId === selectedRootId)) {
      setSelectedRootId(roots[0].tempId);
    }
  }, [roots, selectedRootId]);

  useEffect(() => {
    if (messaggio) {
      titleRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [messaggio]);

  const selectedSubtree = useMemo(() => {
    const root = roots.find(r => r.tempId === selectedRootId);
    if (!root) return null;
    return { root, nodes: collectSubtree(nodes, root) };
  }, [roots, nodes, selectedRootId]);

   const handleNodeClick = (node) => {
   if (node.tipoFigli != null) return; 
   if (fase === "richiesta") {
     setPendingLeaf(node);
     setOreTemp(oreRichieste || 1);
     setShowOreModal(true);
   } else if (fase === "offerta") {
     if (fogliaRichiesta && node.tempId === fogliaRichiesta.tempId) return;
     setFogliaOfferta(node);
   }
 };

  const inviaProposta = async () => {
    if (!fogliaRichiesta || !fogliaOfferta) return;
    const payload = {
      username,
      idFogliaRichiesta: Number(fogliaRichiesta.tempId.replace("F-", "")),
      oreRichieste,
      idFogliaOfferta: Number(fogliaOfferta.tempId.replace("F-", ""))
    };
    const res = await fetch(`${API_BASE}/api/proposte/crea-proposta`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(payload)
    });
    if (res.ok) {
      setSuccessMsg("Proposta creata con successo.");
      setFogliaRichiesta(null);
      setFogliaOfferta(null);
      setFase("richiesta");
    } else {
      setSuccessMsg("Errore durante la creazione della proposta.");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2 ref={titleRef}>CREA PROPOSTA DI SCAMBIO</h2>
      {messaggio && (
        <div
          className={`alert ${
            messaggio.includes("successo") ? "alert-success" : "alert-danger"
          } d-inline-block`}
          role="alert"
          style={{ maxWidth: "500px" }}
        >
          {messaggio}
        </div>
      )}

      <div style={{ marginBottom: 20 }}>
        <label>
          Scegli la gerarchia di <span style={{ fontWeight: "bold", color: "red" }}>servizi</span> da visualizzare:&nbsp;
          <select
            className="form-select w-100 mt-2"
            value={selectedRootId || ""}
            onChange={(e) => setSelectedRootId(e.target.value)}
          >
            {roots.map(r => (
              <option key={r.tempId} value={r.tempId}>{r.nome}</option>
            ))}
          </select>
        </label>
        <hr className="my-4" />
      </div>


      {fase === "richiesta" && (
      <>
        <div className="d-flex justify-content-between align-items-center mb-2" style={{ gap: 12 }}>
          <h4 className="mb-0">1. Seleziona il <span style={{ fontWeight: "bold", color: "red" }}>servizio</span> che vuoi richiedere</h4>
          {fogliaRichiesta && !fogliaOfferta && (
            <button
              className="btn btn-success"
              onClick={() => { setFase("offerta"); }}
            >
              Conferma servizio richiesto
            </button>
          )}
        </div>
        <p className="text-muted mb-3">Clicca su un servizio qualsiasi e successivamente inserisci le ore che richiedi</p>
      </>
    )}

      {fase === "offerta" && (
        <>
          <h4>2. Seleziona il <span style={{ fontWeight: "bold", color: "red" }}>servizio</span> che vuoi offrire</h4>
          <p>Clicca su un servizio da offrire in cambio, il conteggio delle ore offerte verrà svolto in automatico</p>
        </>
      )}

    <div>
      {selectedSubtree && (
        <TreeCanvas
          all={selectedSubtree.nodes}
          root={selectedSubtree.root}
          readOnly={true}
          onAddChildren={() => {}}
          onRemove={() => {}}
          handleLeafClick={handleNodeClick}
          selectedLeafId={
            (fase === "richiesta" ? fogliaRichiesta?.tempId : fogliaOfferta?.tempId) || null
          }
          disabledLeafId={fase === "offerta" ? fogliaRichiesta?.tempId : null}
        />
      )}
    </div>

      <div style={{ marginTop: 20 }}>
      {fase === "offerta" && fogliaRichiesta && fogliaOfferta && (
        <button className="btn btn-success mt-4" onClick={inviaProposta}>
          Crea proposta
        </button>
      )}
      </div>

      {showOreModal && (
      <div
        onClick={() => { setShowOreModal(false); setPendingLeaf(null); }}   // chiude e annulla selezione
        style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,.35)",
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 1000
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{ background: "#fff", padding: 16, borderRadius: 8, minWidth: 280 }}
        >
          <h5 style={{ marginTop: 0 }}>Ore richieste</h5>
          <div className="d-flex align-items-center" style={{ gap: 8 }}>
            <input
              type="number"
              min={1}
              step={1}
              value={oreTemp}
              onChange={(e) => setOreTemp(Math.max(1, Number(e.target.value || 1)))}
              className="form-control"
              style={{ width: 100 }}
            />
            <button
              className="btn btn-primary"
              onClick={() => {
                if (!pendingLeaf) return;
                setFogliaRichiesta(pendingLeaf);  
                setOreRichieste(oreTemp);         
                setPendingLeaf(null);
                setShowOreModal(false);
              }}
            >
              Conferma
            </button>
            <button className="btn btn-light" onClick={() => {setShowOreModal(false); setPendingLeaf(null); }}>
              Annulla
            </button>
          </div>
        </div>
      </div>
    )}
    </div>
  );
}

// converte nodo da backend
function adaptNodeFromApi(n) {
  const id = Number(n.id);
  const parent = Number(n.idPadre ?? n.id_padre ?? null);
  const tipoFigli = n.tipoFigli ?? n.tipofigli ?? null;
  const tempId = tipoFigli == null ? `F-${id}` : `N-${id}`;
  const idPadre = parent == null ? null : `N-${parent}`;

  return {
    tempId,
    idPadre,
    isRadice: Boolean(n.isRadice ?? n.isradice ?? parent == null),
    nome: n.nome,
    campo: n.campo ?? null,
    tipoFigli,
    dominioVal: n.dominioVal ?? n.dominio_val ?? null,
    descrizione: n.descrizione ?? null,
    conversionFactor: n.fattore ?? n.conversionFactor ?? null,
  };
}
